import React from "react";
import axios from "axios";
import { blink } from '../blink';
import { name } from '../test';
import { gaze } from '../gaze';
import { calcScore, findVariance, findAverage } from "../algo"
// import { getTextureShapeFromLogicalShape } from "@tensorflow/tfjs-backend-webgl/dist/webgl_util";

class AttendeeView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            totalBlinkCount: 0,
            isBlinking: false,
            baselineCreated: false,
            attendeeId: props.attendeeId,
            meetingId: props.meetingId
        }
        this.currGazeData = [];
        this.baselineBlinks = [];
        this.baselineGazeVars = [];
        this.baselineBlinkCount = 0;
        this.baselineGazeVar = {};
        this.intervalMs = 3000;
        this.cutoff = this.intervalMs * 5 / 1000;
        
        this.numRunning = 6;
        this.runningScores = Array(this.numRunning).fill(100);
    }

    componentDidMount() {
        gaze.startGazeTracking(this);
        let modelLoadPromise = blink.loadModel();

        modelLoadPromise.then(
            (result) => {
                this.setState({
                    isLoaded: true
                });

                const videoElement = document.querySelector("video");

                let times = 0;
                setInterval(
                    () => {
                        if (times < this.cutoff) {
                            //blink
                            this.baselineBlinks.push(this.state.totalBlinkCount);
                            
                            //gaze
                            const xGaze = this.currGazeData.map(obj => obj.x)
                            const yGaze = this.currGazeData.map(obj => obj.y)
                            const xVar = findVariance(xGaze)
                            const yVar = findVariance(yGaze)
                            this.baselineGazeVars.push({x: xVar, y: yVar})
                        }
                        if (times === this.cutoff) {
                            // blink
                            this.baselineBlinkCount = this.findMedian(this.baselineBlinks);
                            console.log(this.baselineBlinkCount);

                            //gaze
                            const xVars = this.baselineGazeVars.map(obj => obj.x)
                            const yVars = this.baselineGazeVars.map(obj => obj.y)
                            this.baselineGazeVar.x = this.findMedian(xVars)
                            this.baselineGazeVar.y = this.findMedian(yVars)
                            console.log(this.baselineGazeVar)

                            this.setState({
                                baselineCreated: true
                            })
                        }
                        if (times > this.cutoff) {
                            const baselineBlinkRate = this.baselineBlinkCount / this.intervalMs * 1000
                            const baselines = [baselineBlinkRate, this.baselineGazeVar]

                            const currBlinkRate = this.state.totalBlinkCount / this.intervalMs * 1000
                            const currScore = calcScore(baselines, currBlinkRate, this.currGazeData);
                            // update running
                            this.runningScores.shift();
                            this.runningScores.push(currScore);
                            const score = findAverage(this.runningScores)

                            let scorePostPromise = axios.post(`http://144.126.212.184:8000/score/${this.state.meetingId}`, {
                                attendeeId: this.state.attendeeId,
                                score: score
                            });
                            scorePostPromise.then(result =>{
                                console.log(result);
                            }, error => {
                                console.log(error);
                            })
                            console.log("score:", score, "running scores:", this.runningScores)
                        }
                        this.state.totalBlinkCount = 0;
                        this.currGazeData.length = 0;
                        times++;

                    }, this.intervalMs
                );

                const init = async () => {
                    await blink.setUpCamera(videoElement);
                };
                init().then(
                    (res) => {
                        const predict = async () => {
                            const blinkPrediction = await blink.getBlinkPrediction();
                            // console.log(blinkPrediction);
                            if (
                                blinkPrediction !== undefined &&
                                blinkPrediction.blink !== undefined &&
                                blinkPrediction.blink !== this.state.isBlinking
                            ) {
                                if (!this.state.isBlinking) {
                                    this.setState({
                                        totalBlinkCount: this.state.totalBlinkCount + 1,
                                        isBlinking: blinkPrediction.blink,
                                    });
                                    // console.log('Blink: ', blinkPrediction);
                                } else {
                                    this.setState({
                                        isBlinking: blinkPrediction.blink,
                                    });
                                }
                            }

                            let raf = requestAnimationFrame(predict);
                        };
                        predict();
                    },
                    (err) => {
                        console.log("predict line2");
                        console.log(err);
                    }
                );
            },
            (err) => {
                console.log(err);
            }
        );
    }

    findMedian = arr => {
        const mid = Math.floor(arr.length / 2),
            nums = [...arr].sort((a, b) => a - b);
        return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
    }

    render() {
        return (
            <div>
                <h1>Great! You are all set. Keep this tab open on a different window</h1>
                <h3>Don't forget to fill out the google form afterwards</h3>
            </div>
        );
    }
}

export default AttendeeView;
